var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getActiveDiagram } from '../theme';
import { createDiagramGroup, separateOverlappingNodes, readCanvasSize, } from '../helpers';
import { createClassNode, } from '../primitives';
import { collectObstacles } from '../router';
import { connectNodePairs } from '../connectors';
import { maybeApplyDiagramFlow } from '../flow';
/** Create UML class diagram */
export function createClassDiagram(app, data, options) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d, _e, _f, _g, _h;
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'classDiagram', __assign(__assign({}, options), { data: data }), { name: 'classDiagram' });
    var nodeMap = new Map();
    try {
        for (var _j = __values(data.classes), _k = _j.next(); !_k.done; _k = _j.next()) {
            var cls = _k.value;
            var nodeGroup = createClassNode(app, cls.name, (_d = cls.attributes) !== null && _d !== void 0 ? _d : [], (_e = cls.methods) !== null && _e !== void 0 ? _e : []);
            nodeGroup.x = (_f = cls.x) !== null && _f !== void 0 ? _f : 0;
            nodeGroup.y = (_g = cls.y) !== null && _g !== void 0 ? _g : 0;
            if (typeof cls.rotation === 'number')
                nodeGroup.rotation = cls.rotation;
            nodeGroup.metadata = __assign(__assign({}, nodeGroup.metadata), { diagramId: cls.id });
            nodeMap.set(cls.id, nodeGroup);
            group.add(nodeGroup);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var canvas = readCanvasSize(options);
    separateOverlappingNodes(__spreadArray([], __read(nodeMap.values()), false), {
        gap: 24,
        canvasW: canvas.width,
        canvasH: canvas.height,
    });
    var allNodes = __spreadArray([], __read(nodeMap.values()), false);
    var edgeLayer = app.group({ zIndex: -10, listening: false });
    edgeLayer.metadata.diagramEdgeLayer = true;
    var pairs = [];
    try {
        for (var _l = __values(data.relations), _m = _l.next(); !_m.done; _m = _l.next()) {
            var rel = _m.value;
            var from = nodeMap.get(rel.from);
            var to = nodeMap.get(rel.to);
            if (!from || !to)
                continue;
            var common = {
                glow: false,
                cornerRadius: 10,
                style: 'smart',
                edgeId: "".concat(rel.from, "->").concat(rel.to, ":").concat((_h = rel.type) !== null && _h !== void 0 ? _h : 'rel'),
                fromId: rel.from,
                toId: rel.to,
            };
            if (rel.type === 'inheritance') {
                pairs.push({
                    from: from,
                    to: to,
                    options: __assign(__assign({}, common), { stroke: getActiveDiagram().umlInheritance, arrowEnd: 'hollow' }),
                });
            }
            else if (rel.type === 'association') {
                pairs.push({
                    from: from,
                    to: to,
                    options: __assign(__assign({}, common), { stroke: getActiveDiagram().umlAssociation, arrowEnd: 'open' }),
                });
            }
            else if (rel.type === 'composition') {
                pairs.push({
                    from: from,
                    to: to,
                    options: __assign(__assign({}, common), { stroke: getActiveDiagram().umlComposition, arrowStart: 'diamond', arrowEnd: 'none' }),
                });
            }
            else {
                pairs.push({
                    from: from,
                    to: to,
                    options: __assign(__assign({}, common), { stroke: getActiveDiagram().umlImplements, dash: rel.type === 'implements' ? [6, 4] : undefined, arrowEnd: 'hollow' }),
                });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_b = _l.return)) _b.call(_l);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _o = __values(connectNodePairs(app, pairs, {
            parent: group,
            obstacleNodes: allNodes,
            obstacles: collectObstacles(allNodes),
            style: 'smart',
            glow: false,
        })), _p = _o.next(); !_p.done; _p = _o.next()) {
            var g = _p.value;
            edgeLayer.add(g);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_p && !_p.done && (_c = _o.return)) _c.call(_o);
        }
        finally { if (e_3) throw e_3.error; }
    }
    group.add(edgeLayer);
    maybeApplyDiagramFlow(app, group, options);
    return group;
}
